<template>
  <transition name="fade">
    <div class="c-confirm" v-show="isShow">
      <div class="c-confirm_box">
        <i class="c-confirm_close" @click="close"></i>
        <input
          v-model="password"
          @blur="screenFix"
          @focus="focus"
          type="password"
        />
        <span v-show="error" class="c-confirm_error">密码有误, 请重新输入</span>
        <i class="c-confirm_btn" @click="submit"></i>
      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">
import { appService } from "../services/app.service";
export default {
  data() {
    return {
      isShow: false,
      password: "",
      error: false,
      type: "",
    };
  },
  methods: {
    // ios端兼容问题
    screenFix() {
      window.scrollBy(0, 1);
    },

    focus() {
      this.error = false;
    },

    close() {
      this.password = "";
      appService.confirm$.next({ isOpen: false });
    },

    submit() {
      if (this.password == appService.password[this.type]) {
        appService[this.type + "$"].next(true);
        if (this.type === "auth") appService.overall$.next(true);
        appService.confirm$.next({ isOpen: false, type: "" });
        this.password = "";
      } else {
        this.password = "";
        this.error = true;
      }
    },
  },
  mounted() {
    // console.log(appService.auth$);

    appService.confirm$.subscribe((res) => {
      // console.log('appService.confirm$', res);
      this.isShow = res.isOpen;
      this.type = res.type;

      console.log({ res });
    });
  },
};
</script>

<style lang="scss" scoped>
.c-confirm {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;

  &_box {
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -224px 0 0 -318px;
    width: 636px;
    height: 448px;
    background: url(../assets/luckdraw/confirm.png) center/100% no-repeat;

    input {
      position: absolute;
      left: 90px;
      top: 180px;
      padding: 0;
      width: 400px;
      height: 70px;
      font-size: 26px;
      line-height: 70px;
      background: transparent;
      border: 0;
      outline: 0;
    }
  }
  &_close {
    position: absolute;
    right: 10px;
    top: 14px;
    width: 50px;
    height: 50px;
    // border: 1px solid;
    cursor: pointer;
  }
  &_error {
    position: absolute;
    left: 70px;
    top: 258px;
    width: 500px;
    height: 76px;
    font-size: 18px;
    color: #e11616;

    // border: 1px solid;
  }
  &_btn {
    position: absolute;
    left: 70px;
    top: 308px;
    width: 500px;
    height: 76px;
    // border: 1px solid;
  }
}
</style>
